import "../personaldetails/PersonalDetails.css";
import { generateUniqueId } from "config/config";
import React, { useEffect, useState } from "react";

const ViewPermissionAccess = ({ accessPermissionData }) => {
  const [permissionArray, setPermissionArray] = useState([
    {
      name: "Dashboard",
      title: "dashboard",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "user",
      name: "User Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "recipe",
      name: "Recipe Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "article",
      name: "Articles Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "content",
      name: "Content Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Delete",
          value: "delete",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },

    {
      title: "subscription",
      name: "Subscription Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Delete",
          value: "delete",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },
    {
      title: "activity",
      name: "Activity Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Delete",
          value: "delete",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },
    {
      title: "report",
      name: "Report Management",
      permission: [
        {
          title: "View",
          value: "read",
          isPermission: false,
        },
        {
          title: "Edit",
          value: "write",
          isPermission: false,
        },
      ],
      uniqId: generateUniqueId("sub-admin"),
    },
  ]);

  // set Sub AdminDetails Handler
  const setSubAdminDetailsHandler = () => {
    const updatedPermissions = permissionArray.map((module) => {
      const title = module.title;

      const updatedPermissionsList = module.permission.map((perm) => {
        const permissionKey = `${title}.${perm.value}`;
        return {
          ...perm,
          isPermission: accessPermissionData.includes(permissionKey),
        };
      });

      return {
        ...module,
        permission: updatedPermissionsList,
      };
    });

    setPermissionArray(updatedPermissions);
  };

  useEffect(() => {
    setSubAdminDetailsHandler();
  }, []);

  //***************************** Return HTML CODE **************************//
  return (
    <div className="personal_details_parents">
      <div className="access_heading">
        <h1>Access to</h1>
      </div>

      <div className="check_box_wrap my-1">
        {permissionArray?.length > 0 &&
          permissionArray?.map((item, ind) => (
            <div key={item?.uniqId} className="view_checkbox">
              <h6>{item?.name}</h6>
              {item?.permission?.map((el, i) => (
                <label key={i + 1}>
                  <input
                    readOnly
                    type="checkbox"
                    checked={el?.isPermission}
                    defaultValue={el?.isPermission}
                    style={{ cursor: "not-allowed" }}
                  />{" "}
                  <span>{el?.title}</span>
                </label>
              ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default ViewPermissionAccess;
